import {
  Inject,
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RegisterValidators } from '../../validators/register-validators';
import { ErrorMessageUtils } from '../../utils/ErrorMessageUtils';
import { Auth, confirmPasswordReset } from 'firebase/auth';
import { FIREBASE_AUTH } from '../../firebase.providers';
import { AlertSeverity } from '../../ui/alert.component';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmComponent implements OnInit {
  mode? = this.route.snapshot.queryParams['mode'];
  code? = this.route.snapshot.queryParams['oobCode'];

  password = new FormControl('', [
    Validators.required,
    Validators.minLength(6),
  ]);
  confirm_password = new FormControl('', [
    Validators.required,
    Validators.minLength(6),
  ]);

  resetPasswordForm: FormGroup = new FormGroup(
    {
      password: this.password,
      confirm_password: this.confirm_password,
    },
    [RegisterValidators.match('password', 'confirm_password')],
  );

  inSubmission: boolean = false;
  showAlert: boolean = false;
  severity: AlertSeverity = 'info';
  message: string = '';

  constructor(
    @Inject(FIREBASE_AUTH) private auth: Auth,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (this.mode === 'verifyEmail') {
      this.verifyEmail(this.code);
    } else if (this.mode === 'verifyAndChangeEmail') {
      this.applyEmailChange(this.code);
    }
  }

  async verifyEmail(code: string) {
    await this.authService.verifyEmailWithCode(code).then(
      () => {
        this.router.navigate(['/login', { showEmailVerifiedMessage: true }]);
      },
      (error) => {
        this.router.navigate([
          '/login',
          { showEmailNotYetVerifiedMessage: true },
        ]);
      },
    );
  }

  /** Applies a verifyBeforeUpdateEmail link (/mijn-gegevens). The same applyActionCode
   *  handles this mode: server-side it sets both the new address and emailVerified.
   *  Applying it revokes the refresh tokens, so the old session is dead either way;
   *  signing out here makes that immediate instead of at the next token refresh. A
   *  taken address only fails at this point, not when the link was requested. */
  async applyEmailChange(code: string) {
    try {
      await this.authService.verifyEmailWithCode(code);
      await this.authService.logoutUserWithoutRedirect();
      await this.router.navigate(['/login', { showEmailChangedMessage: true }]);
    } catch {
      await this.router.navigate([
        '/login',
        { showEmailChangeFailedMessage: true },
      ]);
    }
  }

  async resetPassword() {
    if (this.password.value) {
      this.inSubmission = true;
      try {
        await confirmPasswordReset(this.auth, this.code, this.password.value);
        this.inSubmission = false;
        this.showAlert = true;
        this.severity = 'success';
        this.message = 'Reset succes!';
        setTimeout(() => {
          this.router.navigateByUrl('/login');
        }, 500);
      } catch (error: any) {
        this.inSubmission = false;
        this.showAlert = true;
        this.severity = 'error';
        this.message =
          ErrorMessageUtils.determineFrontendMessageBasedOnError(error);
      }
    }
  }
}
